export default {
  TASK: 'TASKS',
  NOTES: 'NOTES',
  CASE_FILES: 'CASE_FILES',
  DETAILS: 'DETAILS',
  PATIENT_DETAILS: 'PATIENT_DETAILS',
  PRESCRIPTIONS: 'PRESCRIPTIONS',
  PRESCRIPTION_NEW: 'PRESCRIPTION_NEW',
  PRESCRIPTION_EDIT: 'PRESCRIPTION_EDIT',
  WORKFLOW: 'WORKFLOW',
  AUDIT_LOGS: 'AUDIT_LOGS',
  ACTIVITY_LOGS: 'ACTIVITY_LOGS',
  COMMENTS: 'COMMENTS',
  CHAT: 'CHAT',
  PLANS: 'PLANS',
  PRODUCTION: 'PRODUCTION',
  PRODUCTION_BATCH_DETAILS: 'PRODUCTION_BATCH_DETAILS',
  TRACKING: 'TRACKING',
  TREATMENT_STARTED_INTRO: 'TREATMENT_STARTED_INTRO',
  ORDERS: 'ORDERS',
  PAYMENT: 'PAYMENT',
  PAYMENT_REMINDERS: 'PAYMENT_REMINDERS',
  VIEW_TREATMENT_PLAN: 'VIEW_TREATMENT_PLAN',
  WEAR_STATS: 'WEAR_STATS',
  FILES: 'FILES',
  FILES_SUMMARY: 'FILES_SUMMARY',
  OVERVIEW: 'OVERVIEW',
  APPOINTMENTS: 'APPOINTMENTS',
  ADD_APPOINTMENT: 'ADD_APPOINTMENT',
  VIEW_APPOINTMENT: 'VIEW_APPOINTMENT',

  CUSTOMER_TABS: 'CUSTOMER_TABS',
  CUSTOMER_PRESCRIPTION: 'CUSTOMER_PRESCRIPTION',
  CUSTOMER_CASE_RECORD: 'CUSTOMER_CASE_RECORD',
  CUSTOMER_PLANS: 'CUSTOMER_PLANS',
  CUSTOMER_VIEW_TREATMENT_PLAN: 'CUSTOMER_VIEW_TREATMENT_PLAN',
  VIEW_ORDER: 'VIEW_ORDER',
  CUSTOMER_TREATMENT_SUMMARY: 'CUSTOMER_TREATMENT_SUMMARY',

  VSP_TABS: 'VSP_TABS',
  VSP_PLANS: 'VSP_PLANS',
  VSP_CASE_RECORD: 'VSP_CASE_RECORD',
  VSP_PRESCRIPTION: 'VSP_PRESCRIPTION',
  VSP_TREATMENT_SUMMARY: 'VSP_TREATMENT_SUMMARY',
  CASE_DETAILS: 'CASE_DETAILS',
  VSP_PRODUCTION: 'VSP_PRODUCTION',
  VSP_TRACKING: 'VSP_TRACKING',
  VSP_RETENTION: 'VSP_RETENTION',
} as const
